<template>
     <alphabet-list
        :letters="displayLetters"
        :selected-letter="selectedLetter"
        @select-letter="onSelectLetter"
    />
    <div class="row">
        <div class="col-12" v-for="(download) in displayDownloads">
                <div class="row element-download">
                    <div class="col-6 col-md-8 download-content">
                        <h3 v-if="download.titel">{{download.titel}}</h3>
                        <p v-if="download.teaser">{{download.teaser}}</p>
                    </div>
                    <div class="col-6 col-md-4 p-0 download-info">
                        <div class="download-block">
                            <a class="btn btn-download" :href="download.url" :download="download.name">Datei herunterladen</a>
                            <span class="fileinfo">PDF / {{download.size}}</span>
                        </div>
                    </div>
                </div>
        </div>
        <more-button :total="totalCount??0" :elements="displayDownloads.length" :element="selectedLetter" :emit="'loadMoreDownloads'"></more-button>
    </div>

</template>

<script setup lang="ts">
    import { onMounted } from 'vue';
    import alphabetList from '../product-overview/aplhabet-list/alphabet-list.vue';
    import { useDownloadOverview } from './useDownloadOverview';
    import { emitterInstance } from '@/classes/emitter';
    import moreButton from '../content-search/searchOverlay/more-button.vue';

    const {
        selectedLetter,
        totalCount,
        displayDownloads,
        displayLetters,
        onSelectLetter,
        initOverview,
        getMoreResults
    } = useDownloadOverview();

   onMounted(async() =>{
    await initOverview();
    
    emitterInstance.on("loadMoreDownloads", (letter:any):void => {
        getMoreResults(letter);
    });
   });
</script>